var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggridFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/20px/filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M12.1875 13.5883V16.3448C12.1875 16.8513 11.8463 17.2924 11.3589 17.4151L9.17137 17.9666C8.481 18.1404 7.8125 17.6145 7.8125 16.8963V11.3824L3.25638 6.78797C3.09188 6.62208 3 6.39796 3 6.16414V3.88236C3 3.3953 3.392 3 3.875 3H16.125C16.608 3 17 3.3953 17 3.88236V4.76472",
    stroke: "#84827F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M12.7995 9.89388H17.9993",
    stroke: "#84827F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    d: "M15.3994 12.4938V7.29395",
    stroke: "#84827F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggridFilter);
export default __webpack_public_path__ + "static/media/aggrid-filter.044348029ddce8e78a6595179ef54da7.svg";
export { ForwardRef as ReactComponent };